<section class="view-invoice-hts">
  <header class="view-invoice-hts-header">
    <div class="view-invoice-hts-header-column-index">#</div>
    <div class="view-invoice-hts-header-column-code">{{ "LABELS.HTS_CODE" | translate }}</div>
    <div class="view-invoice-hts-header-column-main-wrapper">
      <div class="view-invoice-hts-header-column-main">{{ "LABELS.COUNTRY_OF_ORIGIN" | translate }}</div>
      <div class="view-invoice-hts-header-column-main">{{ "LABELS.GROSS_WEIGHT" | translate }}</div>
      <div class="view-invoice-hts-header-column-main">{{ "LABELS.QUANTITY" | translate }}</div>
      <div class="view-invoice-hts-header-column-main">{{ "LABELS.ENTERED_VALUE" | translate }}</div>
    </div>
    <div class="view-invoice-hts-header-column-actions" [ngClass]="{ 'bulk-mode': isCanBulkDelete && isMultiSelectMode }">
      <ng-container *ngIf="isCanBulkDelete && invoice?.lines?.length">
        <dropdown-action *ngIf="!isMultiSelectMode" className="" [id]="'hts-bulk-menu-' + invoice.id">
          <button type="button" dropdown-item class="dropdown-item" (click)="enterMultiSelect()">
            {{ "MULTIPLE_CHOICE" | translate }}
          </button>
          <button type="button" dropdown-item class="dropdown-item" (click)="openRemoveAllModal()">
            {{ "REMOVE_ALL_LINE_ITEMS" | translate }}
          </button>
        </dropdown-action>

        <ng-container *ngIf="isMultiSelectMode">
          <span
            class="view-invoice-hts-header-bulk-exit"
            nz-popover
            nzPopoverOverlayClassName="tooltip-sm"
            nzPopoverTrigger="hover"
            [nzPopoverContent]="'BUTTON.CANCEL' | translate"
            [attr.aria-label]="'BUTTON.CANCEL' | translate"
            role="button"
            tabindex="0"
            (click)="exitMultiSelect()"
            (keydown.enter)="exitMultiSelect()"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
          </span>
          <div
            class="view-invoice-hts-header-bulk-trash"
            [ngClass]="{ 'is-disabled': !selectedIds.size }"
            nz-popover
            nzPopoverOverlayClassName="tooltip-sm"
            nzPopoverTrigger="hover"
            [nzPopoverContent]="'BULK_DELETE_LINE_ITEMS_TITLE' | translate"
            [attr.aria-label]="'BULK_DELETE_LINE_ITEMS_TITLE' | translate"
            role="button"
            [attr.tabindex]="selectedIds.size ? 0 : null"
            (click)="openBulkDeleteModal()"
            (keydown.enter)="openBulkDeleteModal()"
          >
            <img src="assets/icons/icon_trash.svg" class="view-invoice-hts-header-bulk-trash-img" />
          </div>
          <span
            class="chk"
            [ngClass]="{
              'is-checked': masterState === 'checked',
              'is-indeterminate': masterState === 'indeterminate'
            }"
            role="checkbox"
            tabindex="0"
            [attr.aria-checked]="masterState === 'indeterminate' ? 'mixed' : masterState === 'checked'"
            [attr.aria-label]="'LABELS.SELECT_ALL_ROWS' | translate"
            (click)="onMasterClick()"
            (keydown.enter)="onMasterClick()"
            (keydown.space)="$event.preventDefault(); onMasterClick()"
          >
            <svg class="chk-icon tick" width="12" height="12" viewBox="0 0 24 24" fill="none" *ngIf="masterState === 'checked'">
              <path d="M5 12.5l4.2 4.2L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg class="chk-icon minus" width="12" height="12" viewBox="0 0 24 24" fill="none" *ngIf="masterState === 'indeterminate'">
              <path d="M6 12h12" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" />
            </svg>
          </span>
          <dropdown-action [isCustomButton]="true" className="" [id]="'hts-bulk-select-menu-' + invoice.id">
            <i custom-dropdown-button class="fa fa-caret-down view-invoice-hts-header-bulk-caret" aria-hidden="true"></i>
            <button type="button" dropdown-item class="dropdown-item" (click)="selectAll()">
              {{ "BULK_SELECT_ALL" | translate }}
            </button>
            <button type="button" dropdown-item class="dropdown-item" (click)="selectNone()">
              {{ "BULK_SELECT_NONE" | translate }}
            </button>
          </dropdown-action>
        </ng-container>
      </ng-container>
    </div>
  </header>

  <div class="view-invoice-hts-body" [ngClass]="{ 'view-invoice-hts-body-empty': !invoice?.lines?.length }">
    <ng-container *ngIf="invoice?.lines?.length; else linesEmpty">
      <div class="view-invoice-hts-body-row" *ngFor="let hts of invoice?.lines; let i = index">
        <div
          class="view-invoice-hts-body-column-index"
          [ngClass]="{
            'view-invoice-hts-body-column-index-error':
              !hts?.htsNumber ||
              !hts?.countryOfOrigin?.description ||
              !hts?.grossWeight ||
              !unitOfMeasure(hts) ||
              !hts?.value ||
              !hts?.description
          }"
        >
          {{ indexOffset + i + 1 }}
        </div>

        <div class="view-invoice-hts-body-column-code">
          <div class="view-invoice-hts-code-item-container">
            <div class="view-invoice-hts-code-item-bubble">
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 0 }"></ng-content>
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 1 }"></ng-content>
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 2 }"></ng-content>
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 3 }"></ng-content>
            </div>
            <div class="view-invoice-hts-code-item-dot"></div>
            <div class="view-invoice-hts-code-item-bubble">
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 4 }"></ng-content>
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 5 }"></ng-content>
            </div>
            <div class="view-invoice-hts-code-item-dot"></div>
            <div class="view-invoice-hts-code-item-bubble">
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 6 }"></ng-content>
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 7 }"></ng-content>
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 8 }"></ng-content>
              <ng-content *ngTemplateOutlet="codeGroupItem; context: { htsCode: hts.htsNumber, groupNum: 9 }"></ng-content>
            </div>
          </div>
        </div>

        <div class="view-invoice-hts-body-column-main-wrapper">
          <div class="view-invoice-hts-body-column-main-header">
            <div class="view-invoice-hts-body-column-main">
              <div *ngIf="!!hts?.countryOfOrigin?.description; else rowError">
                {{ hts?.countryOfOrigin?.description }}
              </div>
            </div>

            <div class="view-invoice-hts-body-column-main">
              <div *ngIf="!!hts?.grossWeight; else rowError">
                {{ hts?.grossWeight | number : "1.2-2" }}{{ "WEIGHT_UNIT.KG" | translate }}
              </div>
            </div>

            <div class="view-invoice-hts-body-column-main">
              <div *ngIf="!!unitOfMeasure(hts); else rowError">
                {{ unitOfMeasure(hts) }}
              </div>
            </div>

            <div class="view-invoice-hts-body-column-main">
              <div *ngIf="!!hts?.value; else rowError">
                <span>{{ hts?.value * currencyRate | currency : DEFAULT_CURRENCY_CODE : "$" : "1.2-2" }}</span>
                <span
                  class="view-invoice-hts-body-column-main-non-usd-currency"
                  *ngIf="!!invoice?.currency && invoice.currency !== DEFAULT_CURRENCY_CODE"
                >
                  ({{ hts?.value | currency : "" : "" : "1.2-2" }} {{ invoice?.currency }} )
                </span>
              </div>
            </div>
          </div>

          <div class="view-invoice-hts-body-column-main-footer">
            <div *ngIf="!!hts?.description">
              {{ hts?.description }}
            </div>

            <ng-container
              *ngIf="!hts?.description"
              [ngTemplateOutlet]="rowError"
              [ngTemplateOutletContext]="{ emptyText: 'LABELS.ITEM_DESCRIPTION' }"
            ></ng-container>
          </div>
        </div>
        <div class="view-invoice-hts-body-column-actions">
          <span
            *ngIf="isCanBulkDelete && isMultiSelectMode; else rowActions"
            class="chk"
            [ngClass]="{ 'is-checked': selectedIds.has(hts.id) }"
            role="checkbox"
            tabindex="0"
            [attr.aria-checked]="selectedIds.has(hts.id)"
            [attr.aria-label]="('LABELS.SELECT_ROW' | translate) + ' ' + (indexOffset + i + 1)"
            (click)="toggleRow(hts.id)"
            (keydown.enter)="toggleRow(hts.id)"
            (keydown.space)="$event.preventDefault(); toggleRow(hts.id)"
          >
            <svg class="chk-icon tick" width="12" height="12" viewBox="0 0 24 24" fill="none" *ngIf="selectedIds.has(hts.id)">
              <path d="M5 12.5l4.2 4.2L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <ng-template #rowActions>
            <ng-container *ngIf="canEditLineItems ?? isEditable">
              <div
                class="view-invoice-hts-body-column-actions-icon-trash"
                nz-popover
                nzPopoverOverlayClassName="tooltip-sm"
                nzPopoverTrigger="hover"
                [nzPopoverContent]="'DELETE_LINE_ITEM' | translate"
              >
                <img
                  src="assets/icons/icon_trash.svg"
                  class="view-invoice-hts-body-column-actions-icon-trash-img"
                  (click)="deleteLineItem.emit(hts.id)"
                />
              </div>
              <div
                class="view-invoice-hts-body-column-actions-icon-edit"
                nz-popover
                nzPopoverOverlayClassName="tooltip-sm"
                nzPopoverTrigger="hover"
                [nzPopoverContent]="'EDIT_LINE_ITEM' | translate"
              >
                <img
                  src="assets/icons/icon_pencil_gray.svg"
                  class="view-invoice-hts-body-column-actions-icon-edit-img"
                  (click)="editLineItem.emit(hts.id)"
                />
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>
</section>

<ng-template #rowError let-emptyText="emptyText">
  <div>{{ emptyText | translate }}</div>
</ng-template>

<ng-template #codeGroupItem let-htsCode="htsCode" let-groupNum="groupNum">
  <div class="view-invoice-hts-code-item" *ngIf="!!codeGroupAt(htsCode, groupNum); else codeItemEmpty">
    {{ codeGroupAt(htsCode, groupNum) }}
  </div>
</ng-template>

<ng-template #codeItemEmpty>
  <div class="view-invoice-hts-code-item-empty"></div>
</ng-template>

<ng-template #linesEmpty>
  <div class="view-invoice-hts-empty">
    <div class="view-invoice-hts-empty-text" *ngIf="canEditLineItems ?? isEditable" [innerHTML]="'CREATE_HTS_HINT_OCR' | translate"></div>
    <div class="view-invoice-hts-empty-button-wrapper">
      <button
        type="button"
        class="btn btn-primary view-invoice-hts-empty-button"
        *ngIf="canEditLineItems ?? isEditable"
        (click)="addLineItem.emit()"
      >
        <i class="fa fa-plus mr-2"></i>
        {{ "BUTTON.ADD_ITEM_DETAILS" | translate }}
      </button>
    </div>
  </div>
</ng-template>

<es-line-items-bulk-delete-modal
  *ngIf="isCanBulkDelete"
  [isOpen]="isBulkDeleteModalOpen"
  [isLoading]="isBulkDeleting"
  (confirmed)="onBulkDeleteConfirmed()"
  (cancelled)="onBulkDeleteCancelled()"
></es-line-items-bulk-delete-modal>
